import { render, staticRenderFns } from "./UpdateCreds.vue?vue&type=template&id=4a771a7c&"
import script from "./UpdateCreds.vue?vue&type=script&lang=js&"
export * from "./UpdateCreds.vue?vue&type=script&lang=js&"
import style0 from "./UpdateCreds.vue?vue&type=style&index=0&id=4a771a7c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports